module.exports = __webpack_public_path__ + "img/bg_yqgz.5506f8c2.svg";